import { Wrench, Sparkles, Clock } from 'lucide-react';

export default function FinanceUpdateNotice() {
    return (
        <div className="w-full overflow-y-scroll outline-none flex flex-col select-none">
            <div className="bg-gradient-to-br from-blue-50 via-white to-indigo-50 flex items-center justify-center p-4">
                <div className="max-w-2xl w-full">
                    <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 relative overflow-hidden">
                        <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full blur-3xl opacity-30 -mr-32 -mt-32"></div>
                        <div className="absolute bottom-0 left-0 w-48 h-48 bg-gradient-to-tr from-purple-100 to-pink-100 rounded-full blur-3xl opacity-30 -ml-24 -mb-24"></div>
                        
                        <div className="relative z-10">
                            <div className="flex justify-center mb-6">
                                <div className="relative">
                                    <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full p-4 shadow-lg">
                                        <Wrench className="w-8 h-8 text-white" />
                                    </div>
                                    <div className="absolute -top-1 -right-1">
                                        <Sparkles className="w-5 h-5 text-yellow-400 animate-pulse" />
                                    </div>
                                </div>
                            </div>

                            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-4">
                                We're Upgrading Your Finance Dashboard
                            </h1>

                            <p className="text-gray-600 text-center text-lg mb-8 leading-relaxed">
                                We're working hard to bring you a better, more intuitive finance management experience. Our team is building something special with improved features and a fresh new design.
                            </p>

                            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 mb-8">
                                <h2 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                    <Sparkles className="w-5 h-5 text-indigo-600" />
                                    What's Coming
                                </h2>
                                <ul className="space-y-3">
                                    <li className="flex items-start gap-3">
                                        <span className="text-indigo-600 font-bold mt-1">✓</span>
                                        <span className="text-gray-700">Enhanced analytics and reporting tools</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className="text-indigo-600 font-bold mt-1">✓</span>
                                        <span className="text-gray-700">Streamlined navigation and modern interface</span>
                                    </li>
                                    <li className="flex items-start gap-3">
                                        <span className="text-indigo-600 font-bold mt-1">✓</span>
                                        <span className="text-gray-700">Faster performance and real-time updates</span>
                                    </li>
                                </ul>
                            </div>

                            <div className="flex items-center justify-center gap-3 text-gray-600">
                                <Clock className="w-5 h-5" />
                                <span className="text-sm font-medium">Expected completion: 1/12/2025</span>
                            </div>
                        </div>
                    </div>

                    <div className="mt-6 bg-white/60 backdrop-blur rounded-xl p-4 text-center">
                        <p className="text-sm text-gray-600">
                            Your data is safe and secure. All your information will be automatically available once the update is complete.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
